import { render, staticRenderFns } from "./TotalCategoryCounts.vue?vue&type=template&id=4c5d8872&scoped=true&"
import script from "./TotalCategoryCounts.vue?vue&type=script&lang=js&"
export * from "./TotalCategoryCounts.vue?vue&type=script&lang=js&"
import style0 from "./TotalCategoryCounts.vue?vue&type=style&index=0&id=4c5d8872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d8872",
  null
  
)

export default component.exports